import ApplicationPreview from './ApplicationPreview.page';

export default ApplicationPreview;